<template>
  <div class="terms-and-conditions">
    <div class="content">
      <section class="section">
        <div class="container">
          <vue-markdown class="content-inner" :source="pageContent.Content"></vue-markdown>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import axios from 'axios';

export default {
  name: 'terms',
  components: {
    VueMarkdown,
  },
  data() {
    return {
      pageContent: '',
    };
  },
  mounted() {

    axios.get('https://cms.speedyloans.co.uk/pages/2')
      .then((response) => {
        // console.log(response);
        this.pageContent = response.data;
      })
      .catch((error) => {
        console.log(error.response);
      });

  },
  methods: {

  },
};

</script>


<style lang="scss">

</style>
